<template>
  <div class="toolbar grouping ml-16 mr-16">
    <div class="wrapper">
      <div class="section !tw-flex">
        <div
          v-for="(dimension, dimensionIndex) in groupedDimensions"
          :key="dimension.name"
        >
          <ElDropdown
            v-if="groupingSelectDropdownStatsIndex[dimensionIndex].isShow"
            :show-timeout="0"
            class="select"
            placement="bottom"
            @command="handleGroupingSelect"
          >
            <div
              :class="{active : groupingSelects[dimension.name]}"
              class="select-link"
            >
              <span
                class="text"
                @click.prevent="handleGroupClick($event, dimension)"
              >
                {{ groupingSelectDropdownStatsIndex[dimensionIndex].name }}
              </span>
              <i class="fas fa-chevron-down icon--right" />
            </div>
            <template v-slot:dropdown>
              <ElDropdownMenu class="ddgroup">
                <ElDropdownItem
                  v-for="field in groupingSelectDropdownStatsIndex[dimensionIndex].grouping"
                  :key="field.name"
                  :command="field"
                  :class="{selected : groupingSelects[dimension.name] && groupingSelects[dimension.name].name === field.name}"
                  class="grouping_select_item"
                >
                  {{ field._title }}
                </ElDropdownItem>
              </ElDropdownMenu>
            </template>
          </ElDropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CustomReportsGroupingSelectToolbar',
    props: ['groupedDimensions', 'groupingSelectDropdownStatsIndex', 'groupingSelects'],
    emits: ['grouping-select', 'group-click'],
    methods: {
      handleGroupingSelect(event) {
        this.$emit('grouping-select', event);
      },
      handleGroupClick(event, dimension) {
        this.$emit('group-click', event, dimension);
      },
    },
  };
</script>